interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  const push = (value: number | string) => pages.push(value);

  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i += 1) push(i);
  } else {
    push(1);
    if (page > 3) push('...');
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i += 1) push(i);
    if (page < totalPages - 2) push('...');
    push(totalPages);
  }

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 bg-background-100 px-3 text-sm text-foreground-700 transition hover:border-accent-400 hover:text-accent-700 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((item, index) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`h-9 w-9 rounded-md border text-sm font-medium transition cursor-pointer ${
              item === page
                ? 'border-accent-500 bg-accent-500 text-background-50 dark:text-foreground-950'
                : 'border-background-200 bg-background-100 text-foreground-700 hover:border-accent-400 hover:text-accent-700'
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={`gap-${index}`} className="px-1 text-foreground-500">
            {item}
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 bg-background-100 px-3 text-sm text-foreground-700 transition hover:border-accent-400 hover:text-accent-700 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}